import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import isEqual from 'react-fast-compare'
import { Grid } from '@mui/material'
import Table from '../common/tableWithBackEndPagination'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { PaginationConfig } from '../../Helpers'
import ConfirmDialoag from '../common/ConfirmDialoag'
import Loader from '../../Layout/Loader'
import Button from '../common/Button'
import TextField from '../common/TextField'
import AddDeviceModel from './addDeviceModel'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import { apiFetch } from '../../Utils/apiFetch'
import instance from '../../axios'

let source

const formDefaultState = {
  name: '',
  protocol: '',
  port: '',
  status: 2
}

class DeviceModelsComponent extends Component {
  constructor () {
    super()
    this.state = {
      ...PaginationConfig,
      selectedModel: '',
      addOption: false,
      editOption: false,
      defaultModelList: false,
      onDeleteConfirmation: false,
      tableData: [],
      pagData: '',
      form: { ...formDefaultState },
      protocols: [],
      isVisableBtn: false,
      isVisableBtnForEdit: false
    }
    this.removeDeviceModel = this.removeDeviceModel.bind(this)
    this.checkRequiredFields = this.checkRequiredFields.bind(this)
    this.ag_submit = this.ag_submit.bind(this)
    this.ug_submit = this.ug_submit.bind(this)
    this.modalControle = this.modalControle.bind(this)
    this.modelSelection = this.modelSelection.bind(this)
  }

  componentWillMount () {
    this.fetchModels()
    this.fetchProtocols()
  }

  fetchProtocols = () => {
    instance
      .get('/api/server/protocols')
      .then(response => {
        const res = response.data
        let raw = (res && res.data) || res || {}
        if (raw && !Array.isArray(raw) && raw.data) {
          raw = raw.data
        }

        let protocols = []
        if (Array.isArray(raw)) {
          protocols = raw
            .map(item => {
              if (typeof item === 'string') {
                return {
                  value: item,
                  label: item,
                  key: item,
                  id: item,
                  name: item
                }
              }
              const value =
                item.protocol ||
                item.name ||
                item.value ||
                item.key ||
                item.id ||
                ''
              const label = String(item.label || value)
              return {
                value: String(value),
                label,
                key: String(value),
                id: String(value),
                name: label,
                port: item.port
              }
            })
            .filter(item => item.value)
        } else if (raw && typeof raw === 'object') {
          protocols = Object.keys(raw)
            .map(key => {
              const item = raw[key]
              if (item != null && typeof item === 'object' && !Array.isArray(item)) {
                const value =
                  item.protocol || item.name || item.value || item.key || key
                const label = String(item.label || value)
                return {
                  value: String(value),
                  label,
                  key: String(value),
                  id: String(value),
                  name: label,
                  port: item.port != null ? item.port : undefined
                }
              }
              return {
                value: String(key),
                label: String(key),
                key: String(key),
                id: String(key),
                name: String(key),
                port: item
              }
            })
            .filter(item => item.value)
            .sort((a, b) => a.label.localeCompare(b.label))
        }

        this.setState({ protocols })
      })
      .catch(() => {
        this.setState({ protocols: [] })
      })
  }

  fetchModels = () => {
    const { page, pageSize, itemSearch } = this.state
    if (this.props.logInUser && this.props.logInUser.id) {
      const apiCall = `/api/devices/models?page=${page}&limit=${pageSize}&search=${itemSearch}`
      source = axios.CancelToken.source()
      instance
        .get(apiCall, { cancelToken: source.token })
        .then(response => {
          const res = response.data
          if (res.status === 'success') {
            if (res.data && res.data.data && res.data.data.length) {
              const items = res.data.data.map(item => ({
                ...item,
                statusLabel: item.status === 2
                  ? this.props.translate('enabled')
                  : this.props.translate('disabled')  // status 1 = disabled
              }))
              this.setState({
                tableData: items,
                defaultModelList: true,
                pagData: res.data
              })
            } else {
              this.setState({
                tableData: [],
                defaultModelList: true,
                pagData: ''
              })
            }
          } else if (res?.statusCode === '440') {
            window.location.replace('/login')
          } else if (res.statusCode) {
            const err = res?.message.split(':')
            err[1] = err[1].replace(')', '')
            this.props.dispatch(notifyError(this.props.translate(err[1])))
          }
        })
        .catch(e => {
          console.log('Request canceled = ', e)
        })
    }
  }

  removeDeviceModel (selected) {
    const item = Array.isArray(selected) ? selected[0] : selected
    this.setState({
      onDeleteConfirmation: true,
      selectedModel: item
    })
  }

  deleteItem = () => {
    const { selectedModel } = this.state
    if (selectedModel && selectedModel.id) {
      apiFetch(`/api/devices/removeModel/${selectedModel.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          response.json().then(res => {
            if (res.status === 'success') {
              this.props.dispatch(notifySuccess('deletedSuccessfully'))
              this.fetchModels()
            } else if (res?.statusCode === '440') {
              window.location.replace('/login')
            } else if (res.statusCode) {
              const err = res?.message.split(':')
              err[1] = err[1].replace(')', '')
              this.props.dispatch(notifyError(this.props.translate(err[1])))
            } else {
              throw response
            }
          })
        })
        .catch(() => {
          this.props.dispatch(notifyError(this.props.translate('somthingWentWrongMessage')))
        })
      this.setState({ onDeleteConfirmation: false })
    }
  }

  onCancel = () => {
    this.setState({ onDeleteConfirmation: false })
  }

  handleChangeRowsPerPage = value => {
    this.setState({ pageSize: value }, () => this.fetchModels())
  }

  handleChangePage = value => {
    this.setState({ page: value }, () => this.fetchModels())
  }

  SearchItem = searchValue => {
    source && source.cancel()
    this.setState({ page: 1, itemSearch: searchValue }, () => this.fetchModels())
  }

  checkFloteNumber (n) {
    return Number(n) === n && n % 1 !== 0
  }

  setPagination = data => {
    if (this.state.pagData) {
      let nData = { ...data }
      const lastPage = nData.total / this.state.pageSize
      const isFloat = this.checkFloteNumber(lastPage)
      delete nData.data
      nData.pageSize = this.state.pageSize
      nData.lastPage = isFloat ? parseInt(lastPage + 1) : lastPage
      return nData
    }
    return {}
  }

  openAddForm () {
    this.setState({
      selectedModel: '',
      editOption: false,
      addOption: true,
      defaultModelList: false,
      form: { ...formDefaultState },
      isVisableBtn: false,
      isVisableBtnForEdit: false
    })
  }

  modelSelection (item) {
    const selected = Array.isArray(item) ? item[0] : item
    if (selected) {
      this.setState({
        editOption: true,
        addOption: false,
        selectedModel: selected,
        defaultModelList: false,
        form: { ...selected },
        isVisableBtn: false,
        isVisableBtnForEdit: false
      })
    }
  }

  modalControle () {
    this.setState({
      addOption: false,
      editOption: false,
      selectedModel: '',
      defaultModelList: true,
      isVisableBtn: false,
      isVisableBtnForEdit: false,
      form: { ...formDefaultState }
    })
  }

  handleChange = name => event => {
    const { target } = event
    this.setState(
      prevState => ({
        form: {
          ...prevState.form,
          [name]: target.value
        }
      }),
      () => this.checkRequiredFields()
    )
  }

  handleProtocolChange = (name, selected) => {
    const protocol =
      selected && (selected.value || selected.label || selected.id)
        ? String(selected.value || selected.label || selected.id)
        : ''
    this.setState(
      prevState => ({
        form: {
          ...prevState.form,
          protocol,
          port:
            selected && selected.port != null && selected.port !== ''
              ? selected.port
              : ''
        }
      }),
      () => this.checkRequiredFields()
    )
  }

  handleStatusChange = event => {
    this.setState(
      prevState => ({
        form: {
          ...prevState.form,
          status: event.target.checked ? 2 : 1
        }
      }),
      () => this.checkRequiredFields()
    )
  }

  checkRequiredFields () {
    const { name, protocol, port } = this.state.form
    const changed = !isEqual(this.state.form, this.state.selectedModel)
    if (name && name.trim() && protocol && protocol.trim() && port) {
      this.setState({ isVisableBtn: true })
      if (changed) {
        this.setState({ isVisableBtnForEdit: true })
      }
    } else {
      this.setState({ isVisableBtn: false, isVisableBtnForEdit: false })
    }
  }

  ag_submit () {
    const { name, protocol, port, status } = this.state.form
    const payload = {
      name: name.trim(),
      protocol: protocol.trim(),
      port: port,
      status
    }
    apiFetch('/api/devices/addModel', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        response.json().then(res => {
          if (res.status === 'success') {
            this.props.dispatch(notifySuccess('createdSuccessfully'))
            this.setState({ isVisableBtn: false, isVisableBtnForEdit: false })
          } else if (res?.statusCode === '440') {
            window.location.replace('/login')
          } else if (res.statusCode) {
            const err = res?.message.split(':')
            err[1] = err[1].replace(')', '')
            this.props.dispatch(notifyError(this.props.translate(err[1])))
          } else {
            throw response
          }
        })
      })
      .catch(() => {
        this.props.dispatch(notifyError(this.props.translate('somthingWentWrongMessage')))
      })
    this.setState(
      {
        addOption: false,
        form: { ...formDefaultState },
        defaultModelList: true
      },
      () => this.fetchModels()
    )
  }

  ug_submit () {
    const { selectedModel, form } = this.state
    const { name, status } = form
    const payload = {
      id: selectedModel.id,
      name: name.trim(),
      protocol: selectedModel.protocol,
      port: selectedModel.port,
      status
    }
    apiFetch('/api/devices/updateModel', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        response.json().then(res => {
          if (res.status === 'success') {
            this.props.dispatch(notifySuccess('updatedSuccessfully'))
            this.setState({ isVisableBtn: false, isVisableBtnForEdit: false })
          } else if (res?.statusCode === '440') {
            window.location.replace('/login')
          } else if (res.statusCode) {
            const err = res?.message.split(':')
            err[1] = err[1].replace(')', '')
            this.props.dispatch(notifyError(this.props.translate(err[1])))
          } else {
            throw response
          }
        })
      })
      .catch(() => {
        this.props.dispatch(notifyError(this.props.translate('somthingWentWrongMessage')))
      })
    this.setState(
      {
        editOption: false,
        form: { ...formDefaultState },
        defaultModelList: true
      },
      () => this.fetchModels()
    )
  }

  render () {
    return (
      <div style={{ position: 'relative' }}>
        {this.state.addOption && (
          <AddDeviceModel
            isEdit={false}
            form={this.state.form}
            formSubmit={this.ag_submit}
            handleChange={this.handleChange}
            handleProtocolChange={this.handleProtocolChange}
            handleStatusChange={this.handleStatusChange}
            modalControle={this.modalControle}
            buttonText={this.props.translate('sharedCreate')}
            isVisableBtn={this.state.isVisableBtn}
            protocols={this.state.protocols}
          />
        )}

        {this.state.editOption && (
          <AddDeviceModel
            isEdit={true}
            form={this.state.form}
            selectedModel={this.state.selectedModel}
            formSubmit={this.ug_submit}
            handleChange={this.handleChange}
            handleProtocolChange={this.handleProtocolChange}
            handleStatusChange={this.handleStatusChange}
            modalControle={this.modalControle}
            buttonText={this.props.translate('update')}
            isVisableBtn={this.state.isVisableBtnForEdit}
            protocols={this.state.protocols}
          />
        )}

        {this.state.defaultModelList ? (
          <>
            <Grid container className='breadcrumb-row'>
              <Grid item xs={12} sm={4}>
                <h3 style={{ margin: 0 }}>{this.props.translate('deviceModels')}</h3>
              </Grid>
              <Grid item xs={12} sm={8} style={{ justifyContent: 'flex-end' }}>
                <div style={{ width: '25%', marginRight: 20 }}>
                  <TextField
                    fullWidth
                    label={this.props.translate('search')}
                    value={this.state.itemSearch || ''}
                    onChange={e => this.SearchItem(e.target.value)}
                  />
                </div>
                <Button
                  disabled={false}
                  aria-label='Create'
                  size='small'
                  color='inherit'
                  onClick={() => this.openAddForm()}
                  id='createButton'
                >
                  {this.props.translate('sharedCreate')}
                </Button>
              </Grid>
            </Grid>
            <Table
              rows={this.state.tableData || []}
              pagination={this.setPagination(this.state.pagData)}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleChangePage={this.handleChangePage}
              SearchItem={this.SearchItem}
              onDelete={this.removeDeviceModel}
              onEdit={this.modelSelection}
              onClick={this.modelSelection}
              themecolors={this.props.themecolors}
              isRowIcons={false}
              isCursoPointer
              setSerialNo
              isEditable
              hasAccessOfUpdate={true}
              hasAccessOfDelete={true}
              rowDefinition={rowDefinition(this.props.translate)}
            />
          </>
        ) : (
          !this.state.addOption && !this.state.editOption && <Loader />
        )}

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.deleteItem}
            title={this.props.translate('areYouWantToDelete')}
            children={this.state.selectedModel.name}
          />
        )}
      </div>
    )
  }
}

const mapState = state => ({
  logInUser: state.logInUsers,
  themecolors: state.themecolors
})

const mapStateToProps = connect(mapState)
export const ShowDeviceModels = mapStateToProps(withTranslationWrapper(DeviceModelsComponent))

const rowDefinition = translate => [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: translate('sharedName')
  },
  {
    id: 'protocol',
    numeric: false,
    disablePadding: false,
    label: translate('protocol')
  },
  {
    id: 'port',
    numeric: false,
    disablePadding: false,
    label: translate('port')
  },
  {
    id: 'statusLabel',
    numeric: false,
    disablePadding: false,
    label: translate('status')
  }
]
